var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPresent = function SvgPresent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H15C15.4142 8.25 15.75 8.58579 15.75 9V15.375C15.75 16.4105 14.9105 17.25 13.875 17.25H4.125C3.08947 17.25 2.25 16.4105 2.25 15.375V9ZM3.75 9.75V15.375C3.75 15.5821 3.91789 15.75 4.125 15.75H13.875C14.0821 15.75 14.25 15.5821 14.25 15.375V9.75H3.75Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6.375C0.75 5.33947 1.58947 4.5 2.625 4.5H15.375C16.4105 4.5 17.25 5.33947 17.25 6.375V7.875C17.25 8.91053 16.4105 9.75 15.375 9.75H2.625C1.58947 9.75 0.75 8.91053 0.75 7.875V6.375ZM2.625 6C2.41789 6 2.25 6.16789 2.25 6.375V7.875C2.25 8.08211 2.41789 8.25 2.625 8.25H15.375C15.5821 8.25 15.75 8.08211 15.75 7.875V6.375C15.75 6.16789 15.5821 6 15.375 6H2.625Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3C10.0858 3 9.75 3.33579 9.75 3.75V4.5H10.5C10.9142 4.5 11.25 4.16421 11.25 3.75C11.25 3.33579 10.9142 3 10.5 3ZM8.25 3.75C8.25 2.50736 9.25736 1.5 10.5 1.5C11.7426 1.5 12.75 2.50736 12.75 3.75C12.75 4.99264 11.7426 6 10.5 6H9C8.58579 6 8.25 5.66421 8.25 5.25V3.75Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.125 2.25C7.74632 2.25 8.25 2.75368 8.25 3.375V4.5H7.125C6.50368 4.5 6 3.99632 6 3.375C6 2.75368 6.50368 2.25 7.125 2.25ZM9.75 3.375C9.75 1.92525 8.57475 0.75 7.125 0.75C5.67525 0.75 4.5 1.92525 4.5 3.375C4.5 4.82475 5.67525 6 7.125 6H9C9.41421 6 9.75 5.66421 9.75 5.25V3.375Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 4.5V17.25H8.25V4.5H9.75Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPresent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/present.0fddba91.svg";
export { ForwardRef as ReactComponent };